import "./Banners.scss";
import { useEffect, useState } from "react";
import AddPhoto from "./../../assets/add-photo.png";
import DeleteBtn from "./../../assets/delete-icon.png";

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useMediaQuery,
} from "@mui/material";
import BlueButton from "../../components/BlueButton/BlueButton";
import api from "../../utils/api";
import MessageModals from "../../components/MessageModals/MessageModals";
import { toast } from "react-toastify";

const Banners = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("1"); // Default to Egypt (ID: 32)
  const [image, setImage] = useState(null);
  const [banners, setBanners] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getCountries();
    getBanners();
  }, []);

  useEffect(() => {
    getBanners();
  }, [country]);

  const getCountries = async () => {
    try {
      const res = await api.get("/countries");
      setCountries(res.data.data);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  const getBanners = async () => {
    try {
      setIsLoading(true);
      let url = "/slides?flag=banner";
      if (country) {
        url += `&country_id=${country}`;
      }
      const res = await api.get(url);
      setBanners(res.data.data || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleAddBanner = async (e) => {
    e.preventDefault();
    if (!image) {
      toast.error("الرجاء اختيار صورة");
      return;
    }
    if (isLoading) return; // Prevent multiple submissions
    if (!country) {
      toast.error("الرجاء اختيار البلد");
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("flag", "banner");
      formData.append("image", image);
      if (country) {
        formData.append("country_id", country);
      }

      await api.post("/slides", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Reset form and refresh data
      setImage(null);
      getBanners();
      setIsLoading(false);
    } catch (error) {
      console.error("Error adding banner:", error);
      setIsLoading(false);
      // Add error handling here
    }
  };

  const handleDeleteClick = (banner) => {
    setSelectedBanner(banner);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedBanner(null);
  };

  return (
    <form className="banners" onSubmit={handleAddBanner}>
      <div className="special-header">
        <p className="title">الصور الاعلانية للموقع</p>

        <FormControl
          sx={{
            width: isMobile ? "100%" : "375px",
          }}
        >
          <InputLabel
            htmlFor="outlined-adornment-password"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            البلد
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            displayEmpty={true}
            sx={{ borderRadius: "8px" }}
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          >
            {countries.map((country) => (
              <MenuItem key={country.id} value={country.id}>
                {country.name_ar}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="banners-container">
        <div className="imgs-container">
          <div className="form-img">
            <label htmlFor="image" className="img-control">
              <img
                src={
                  image instanceof File ? URL.createObjectURL(image) : AddPhoto
                }
                alt=""
                className={image ? "is-img" : ""}
              />
              {!image && <span>اضافة صورة</span>}
            </label>
            <input
              type="file"
              id="image"
              onChange={(e) => setImage(e.target.files[0])}
            />
          </div>

          {banners.map((banner) => (
            <div className="img-container" key={banner.id}>
              <img src={banner.image} alt="" />
              <img
                src={DeleteBtn}
                alt=""
                className="delete-btn"
                onClick={() => handleDeleteClick(banner)}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="action-container">
        <BlueButton
          text="حفظ"
          variant="fill"
          size="medium"
          type="submit"
          disabled={isLoading || !image}
          loading={isLoading}
        />
      </div>

      <MessageModals
        open={openDelete}
        currentView="delete"
        route={`/slides/${selectedBanner?.id}`}
        onClose={handleCloseDelete}
        onDataChange={getBanners}
        text="تم حذف الصورة بنجاح"
      />
    </form>
  );
};

export default Banners;
